import { createReducer } from 'redux-create-reducer'
import * as ActionTypes from '../actions/actionTypes.js'

const initialState = { isAuthenticated: false, meta: { name: undefined } }

export const user = createReducer(initialState, {
	[ActionTypes.USER_LOG_IN_REQUEST](state) {
		return { ...state, isAuthenticated: false }
	},
	[ActionTypes.USER_LOG_IN_SUCCESS](state, { payload }) {
		return {
			...state,
			// isAuthenticated: true,
			token: payload.token,
			firstLogin: payload.firstLogin,
			loggedInAt: payload.loggedInAt
		}
	},
	[ActionTypes.USER_LOG_IN_FAILURE](state) {
		return { ...state, meta: { authorized: false, token: '' } }
	},
	[ActionTypes.USER_LOAD_DATA_REQUEST](state) {
		return { ...state, meta: { isFetching: true, didInvalidate: false } }
	},
	[ActionTypes.USER_LOAD_DATA_SUCCESS](
		state,
		{ payload: { meta, receivedAt } }
	) {
		return {
			...state,
			isAuthenticated: true,
			meta: {
				isFetching: false,
				didInvalidate: false,
				lastUpdated: receivedAt,
				...meta
			}
		}
	},
	[ActionTypes.USER_LOAD_DATA_FAILURE](state) {
		return {
			...state,
			isAuthenticated: true,
			noMetaData: true
		}
	},
	[ActionTypes.USER_LOG_OUT_REQUEST](state) {
		return { ...state }
	},
	[ActionTypes.USER_LOG_OUT_SUCCESS](state) {
		return { ...state, authorized: false, token: '' }
	},
	[ActionTypes.USER_LOG_OUT_FAILURE](state) {
		return { ...state }
	}
})



// WEBPACK FOOTER //
// ./src/reducers/user.js